import { defineComponent as _defineComponent } from 'vue';
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router/composables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowRunButton',
    props: {
        id: null,
        full: { type: Boolean },
        title: { default: undefined },
        disabled: { type: Boolean },
        version: { default: undefined },
        force: { type: Boolean },
        variant: { default: "primary" }
    },
    setup(__props) {
        const props = __props;
        const route = useRoute();
        const router = useRouter();
        const runPath = computed(() => `/workflows/run?id=${props.id}${props.version !== undefined ? `&version=${props.version}` : ""}`);
        function routeToPath() {
            if (props.force && route.fullPath === runPath.value) {
                // vue-router 4 supports a native force push with clean URLs,
                // but we're using a __vkey__ bit as a workaround
                // Only conditionally force to keep urls clean most of the time.
                // @ts-ignore - monkeypatched router, drop with migration.
                router.push(runPath.value, { force: true });
            }
            else {
                router.push(runPath.value);
            }
        }
        return { __sfc: true, props, route, router, runPath, routeToPath, faPlay, FontAwesomeIcon, BButton };
    }
});
